import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, "Optimierungs-Maßnahmen Auswahl", -1)
const _hoisted_2 = { class: "questionnaire-list" }
const _hoisted_3 = { class: "row-level2" }
const _hoisted_4 = { class: "radio" }
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["for"]

import {useStore} from "vuex";
import AppActivity from "@/components/AppActivity.vue";

import {ICON_CANCEL, ICON_OK} from "@/lib/icons";
import {useRouter} from "vue-router";
import QuestionnaireRelease from "@/api/types/QuestionnaireRelease";
import UserQuestionnaire from "@/api/types/UserQuestionnaire";
import {ref} from "vue";
import UserQuestionnaireEntity from "@/db/UserQuestionnaireEntity";
import getDb from "@/db/Database";
import ReportRequest from "@/api/requests/ReportRequest";
import QuestionnaireTopic from "@/api/types/QuestionnaireTopic";
import GetReportResponse from "@/api/responses/GetReportResponse";
import {hideSpinner, showAlert, showSpinner} from "@/store";
import {useApiClient} from "@/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'OptimizationActivity',
  setup(__props) {

const icons = [
  ICON_OK,
  ICON_CANCEL
]

const store = useStore()
const router = useRouter()
const api = useApiClient()

const items = {
  1: 'Betriebliche Optimierungs-Maßnahmen',
  // 2: 'Vorgeschlagene Optimierungs-Maßnahmen',
}

const selectedTopics = store.state.selectedTopics

const selectedValue = ref<number|null>(null)

const userQuestionnaire: UserQuestionnaire = store.state.currentQuestionnaire
const release: QuestionnaireRelease = store.state.currentRelease

const onIconClick = async (icon: string) => {
  switch (icon) {
    case ICON_OK:
      if (selectedValue.value) {
        switch (selectedValue.value) {
          case 1:
            await router.push({ name: 'topicOverview' });
            break
          default:
            showAlert('not implemented')
        }
      }
      break
    case ICON_CANCEL:
      store.commit('SET_QUESTIONNAIRE', { questionnaire: null, release: null })
      store.commit('SET_SELECTED_TOPICS', [])
      await router.push({ name: 'menu' })
      break
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    id: "category-filter-activity",
    icons: icons,
    onIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (name, id) => {
          return _createElementVNode("li", { key: id }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: `item-${id}`,
                  value: parseInt('' + id),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event))
                }, null, 8, _hoisted_5), [
                  [_vModelRadio, selectedValue.value]
                ])
              ]),
              _createElementVNode("label", {
                for: `item-${id}`,
                class: "name"
              }, _toDisplayString(name), 9, _hoisted_6)
            ])
          ])
        }), 64))
      ])
    ]),
    _: 1
  }))
}
}

})